import { useCallback, useState } from 'react';

export interface UseCounterOptions {
  min?: number;
  max?: number;
  initial?: number;
}

export const useCounter = (options: UseCounterOptions = {}) => {
  const { min = 0, max = Number.MAX_SAFE_INTEGER, initial = min } = options;
  const [value, setValue] = useState(initial);

  const set = useCallback(
    (v: number) => {
      setValue(() => {
        if (v < min) return min;
        if (v > max) return max;
        return v;
      });
    },
    [min, max],
  );

  const increment = useCallback((step = 1) => set(value + step), [value, set]);
  const decrement = useCallback((step = 1) => set(value - step), [value, set]);
  const reset = useCallback(() => set(initial), [initial, set]);

  const hasNext = value < max;
  const hasPrev = value > min;

  return { value, set, increment, decrement, reset, hasNext, hasPrev };
};
